import { render, staticRenderFns } from "./chainNotion.vue?vue&type=template&id=77ace933&"
import script from "./chainNotion.vue?vue&type=script&lang=js&"
export * from "./chainNotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports